import { parseIsoDate } from '@/utils/common'
import { Translator } from '../../types/ApiResponseTypes'
import { Document, DocumentList } from '@/types/document/documentType'
import { DocumentResponse, isDocumentListResponse } from '@/types/document/documentResponse'

class DocumentResponseTranslator implements Translator<DocumentList> {
  convert(response: any): DocumentList {
    if (isDocumentListResponse(response)) {
      const documentObject: Array<Document> = []
      if (Array.isArray(response)) {
        response.forEach((document: DocumentResponse) => {
          documentObject.push(this.convertToDocumentModel(document))
        })
        return { total: response.total, page: response.page, documents: documentObject }
      }
    }
    return { total: 0, page: 0, documents: [] }
  }

  convertToDocumentModel(response: DocumentResponse): Document {
    return {
      id: response.documentId,
      name: response.name,
      date: parseIsoDate(response.uploadedOn),
      uploadedBy: response.uploadedBy,
      size: response.size,
      version: response.version,
      type: response.type,
      category: response.category,
      extension: response.fileExtension,
      comment: 'contract',
    }
  }
}
export default new DocumentResponseTranslator()
